/* eslint-disable react-hooks/rules-of-hooks */

import { useMediaQuery } from 'react-responsive';

import { BREAKPOINT_VALUES } from '../globals/globals.js';

export const mediaCalculations = {
	isBelowXSmallOnly: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.XSMALL,
		});
	},
	isBelowMobileSmallOnly: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.MOBILESMALL - 1,
		});
	},
	isBelowMobileLargeOnly: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.MOBILELARGE - 1,
		});
	},
	isMobileLargeAndAbove: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.MOBILELARGE,
		});
	},
	isBelowMediumOnly: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.MEDIUM - 1,
		});
	},
	isBelowSmallOnly: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.SMALL - 1,
		});
	},
	isXSmallAndAbove: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.XSMALL,
		});
	},
	isSmallAndAbove: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.SMALL,
		});
	},
	isMediumAndAbove: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.MEDIUM,
		});
	},
	isBelowMedium: () => {
		return useMediaQuery({
			maxWidth: BREAKPOINT_VALUES.MEDIUM - 1,
		});
	},
	isXSmallOnly: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.XSMALL,
			maxWidth: BREAKPOINT_VALUES.SMALL - 1,
		});
	},
	isSmallOnly: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.SMALL,
			maxWidth: BREAKPOINT_VALUES.MEDIUM - 1,
		});
	},
	isMediumOnly: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.MEDIUM,
			maxWidth: BREAKPOINT_VALUES.LARGE - 1,
		});
	},
	isLargeOnly: () => {
		return useMediaQuery({ minWidth: BREAKPOINT_VALUES.LARGE });
	},
	isBetweenSmallAndLarge: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.SMALL,
			maxWidth: BREAKPOINT_VALUES.LARGE - 1,
		});
	},
	isBetweenXSmallAndMedium: () => {
		return useMediaQuery({
			minWidth: BREAKPOINT_VALUES.XSMALL,
			maxWidth: BREAKPOINT_VALUES.MEDIUM - 1,
		});
	},
};

export const Breakpoint = {
	BelowXSmallOnly: ({ children }) => {
		return mediaCalculations.isBelowXSmallOnly() ? children : null;
	},
	BelowMobileLargeOnly: ({ children }) => {
		return mediaCalculations.isBelowMobileLargeOnly() ? children : null;
	},
	MobileLargeAndAbove: ({ children }) => {
		return mediaCalculations.isMobileLargeAndAbove() ? children : null;
	},
	BelowSmallOnly: ({ children }) => {
		return mediaCalculations.isBelowSmallOnly() ? children : null;
	},
	XSmallAndAbove: ({ children }) => {
		return mediaCalculations.isXSmallAndAbove() ? children : null;
	},
	SmallAndAbove: ({ children }) => {
		return mediaCalculations.isSmallAndAbove() ? children : null;
	},
	MediumAndAbove: ({ children }) => {
		return mediaCalculations.isMediumAndAbove() ? children : null;
	},
	BelowMedium: ({ children }) => {
		return mediaCalculations.isBelowMedium() ? children : null;
	},
	XSmallOnly: ({ children }) => {
		return mediaCalculations.isXSmallOnly() ? children : null;
	},
	SmallOnly: ({ children }) => {
		return mediaCalculations.isSmallOnly() ? children : null;
	},
	MediumOnly: ({ children }) => {
		return mediaCalculations.isMediumOnly() ? children : null;
	},
	LargeOnly: ({ children }) => {
		return mediaCalculations.isLargeOnly() ? children : null;
	},
	BetweenSmallAndLarge: ({ children }) => {
		return mediaCalculations.isBetweenSmallAndLarge() ? children : null;
	},
};
